import { useState } from "react";
import { Facebook } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface FacebookPageFacadeProps {
    pageUrl: string;
    title: string;
    height?: number;
}

/**
 * Lightweight "facade" for the Facebook page plugin: the real plugin iframe can load
 * its own video players for timeline posts, so we defer it entirely until clicked.
 */
const FacebookPageFacade = ({ pageUrl, title, height = 500 }: FacebookPageFacadeProps) => {
    const { t } = useLanguage();
    const [loaded, setLoaded] = useState(false);

    if (loaded) {
        return (
            <iframe
                src={`https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(pageUrl)}&tabs=timeline&width=500&height=${height}&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`}
                width="100%"
                height={height}
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title={title}
            />
        );
    }

    return (
        <button
            type="button"
            onClick={() => setLoaded(true)}
            aria-label={`${t('loadFacebookPageLabel')}: ${title}`}
            className="w-full flex flex-col items-center justify-center gap-4 py-16 hover:bg-black/[0.02] transition-colors"
            style={{ minHeight: height }}
        >
            <div className="w-16 h-16 rounded-full bg-[#1877F2] flex items-center justify-center shadow-lg">
                <Facebook className="w-8 h-8 text-white" />
            </div>
            <span className="text-slate-700 font-semibold text-sm">{t('clickToLoadFacebook')}</span>
        </button>
    );
};

export default FacebookPageFacade;
